export var Tabs = {
  baseStyle: {
    tab: {
      color: 'blue.275',
      fontWeight: '600',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '*': {
        transition: 'all 200ms'
      },
      _selected: {
        borderBottom: 'none'
      },
      _active: {
        borderColor: 'transparent',
        boxShadow: 'none',
        outline: 'none'
      },
      _disabled: {
        bg: 'white',
        borderColor: 'grey.300',
        cursor: 'not-allowed',
        _active: {
          bg: 'white !important',
          borderColor: '#EAEAEA !important'
        },
        p: {
          color: 'grey.800'
        }
      },
      _focus: {
        bg: 'white !important',
        boxShadow: '0 0 3px 2px #2182EB',
        clipPath: 'inset(-5px -5px 0px -5px)',
        borderColor: 'blue.300 !important',
        borderBottomWidth: '1px',
        borderBottomColor: 'grey.300'
      }
    },
    tablist: {
      maxWidth: '100%',
      flexWrap: 'wrap',
      border: 'none !important',
      paddingBottom: '1px'
    },
    tabpanel: {
      border: '1px solid',
      borderColor: 'grey.300',
      borderTopColor: 'grey.300',
      borderRadius: '3px'
    }
  },
  variants: {
    line: {
      tab: {
        color: 'blue.275',
        fontSize: 'md',
        marginBottom: 0,
        bg: 'grey.100',
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottom: '4px solid',
        borderBottomColor: 'grey.300',
        fontWeight: 'bold',
        flex: '1 1 32%',
        px: 3,
        py: 3,
        '&:not(:last-of-type)': {
          marginRight: 1
        },
        _focus: {
          borderBottomColor: 'blue.300 !important',
          outline: 'none'
        },
        _selected: {
          color: 'black',
          borderBottomColor: 'blue.300',
          borderBottomWidth: '4px',
          bg: 'white'
        },
        _disabled: {
          opacity: '1',
          cursor: 'not-allowed',
          p: {
            color: 'grey.800'
          }
        },
        _active: {
          bg: '#0D4E8A !important',
          color: 'white !important',
          borderColor: '#0D4E8A !important'
        }
      },
      tablist: {
        borderColor: 'transparent'
      }
    },
    enclosed: {
      tab: {
        bg: 'grey.100',
        border: '1px solid',
        borderColor: 'grey.300',
        borderTopLeftRadius: '3px',
        borderTopRightRadius: '3px',
        fontSize: 'lg',
        px: '1.75rem',
        py: 5,
        '&:not(:last-of-type)': {
          marginRight: '.5rem'
        },
        _focus: {
          borderColor: 'blue.300'
        },
        _selected: {
          bg: 'white',
          borderColor: 'grey.300',
          color: 'black',
          borderBottomColor: 'grey.300'
        },
        _hover: {
          bg: 'blue.150',
          borderColor: 'blue.600',
          borderBottomColor: 'grey.300'
        },
        _active: {
          bg: '#0D4E8A !important',
          color: 'white !important',
          borderColor: 'transparent !important'
        }
      }
    }
  }
};